import React, { useState, useEffect } from 'react';
import { Modal, Select, Button } from 'antd';

// Accept unified dynamic modal props
interface CustomOptionsModalProps {
  open: boolean;
  value?: any;
  onOk: (value: any) => void;
  onCancel: () => void;
  options?: any[];
}

const CustomOptionsModal: React.FC<CustomOptionsModalProps> = ({ open, options = [], value, onOk, onCancel }) => {
  const [selected, setSelected] = useState<any>(value);

  useEffect(() => {
    setSelected(value);
  }, [value, open]);

  return (
    <Modal
      open={open}
      title="Select an Option"
      onOk={() => selected && onOk(selected)}
      onCancel={onCancel}
      okButtonProps={{ disabled: !selected }}
      destroyOnClose
      maskClosable
      footer={[
        <Button key="cancel" onClick={onCancel}>Cancel</Button>,
        <Button key="ok" type="primary" onClick={() => selected && onOk(selected)} disabled={!selected}>Select</Button>,
      ]}
    >
      <Select
        style={{ width: '100%' }}
        placeholder="Select option"
        value={selected}
        onChange={setSelected}
        options={options.map(opt => ({ value: opt, label: opt }))}
        showSearch
        optionFilterProp="label"
      />
    </Modal>
  );
};

export default CustomOptionsModal;
